import React from 'react';

const AmenityCell = (props) => {
    return (<>
        <div style={{ lineHeight: '1.3em' }}>
            {props.row.amenity_name}
        </div>
        <span style={{ fontSize: '0.8em', lineHeight: '0.8em' }}>
            {props.row.category_name}
        </span>
    </>)
}

export default AmenityCell;
